import { render, staticRenderFns } from "./tUserReports.vue?vue&type=template&id=7e307a27&scoped=true"
import script from "./tUserReports.vue?vue&type=script&lang=js"
export * from "./tUserReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e307a27",
  null
  
)

export default component.exports